module.exports = __webpack_public_path__ + "media/images/flags/16/Marshall-Islands-28ead7a4d0552ed208976f347b009bd0.png";